import { useMutation, useQueryClient } from "@tanstack/react-query";

import { ICollectionOption } from "../models/CollectionOption";
import useApiHelper from "../hooks/useApiHelper";

export default function useSingleCollectionOption(id: string) {
  const { patch, del } = useApiHelper();
  const queryClient = useQueryClient();

  const update = useMutation(
    (collectionOption: ICollectionOption) => patch(`/collectionoption/${collectionOption.id}`, collectionOption),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["collection-options"]);
      },
    }
  );

  const remove = useMutation(
    (id: string) => del(`/collectionoption/${id}`),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["collection-options"]);
      },
    }
  );

  return {
    update,
    remove,
  };
}
